var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-dark"},[_vm._m(0),_c('small',[_c('b-table',{attrs:{"small":"","fields":_vm.fields,"items":_vm.items}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"mb-3 text-center text-dark"},[_c('b',[_vm._v(" EVALUACIONES REALIZADAS ")])])
}]

export { render, staticRenderFns }